import { render, staticRenderFns } from "./FhDataTable.vue?vue&type=template&id=86dd8838&scoped=true&"
import script from "./FhDataTable.vue?vue&type=script&lang=js&"
export * from "./FhDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dd8838",
  null
  
)

export default component.exports